import { useTheme } from '../store/ThemeContext';

/**
 * Palette SVG/Recharts (props JS, não className).
 * FONTE: `tailwind.config.js` / `.pen` gleb — espelho manual dos hex usados em
 * sage, stone, success, warning, danger, info. Manter sincronizado à mão.
 */
const PALETTE = {
  // stone
  stone50: '#FAFAF9',
  stone200: '#E7E5E4',
  stone300: '#D6D3D1',
  stone400: '#A8A29E',
  stone500: '#78716C',
  stone600: '#57534E',
  stone700: '#44403C',
  stone800: '#292524',
  stone900: '#1C1917',
  // sage
  sage500: '#7C9E6F',
  sage600: '#5F7E54',
  sage900: '#2F3F2E',
  white: '#FFFFFF',
};

/**
 * Recharts / SVG palette for light and dark surfaces.
 * @param {'light'|'dark'} resolvedTheme
 */
export function getChartTheme(resolvedTheme) {
  const isDark = resolvedTheme === 'dark';
  return {
    grid: isDark ? PALETTE.stone700 : PALETTE.stone200,
    axis: isDark ? PALETTE.stone400 : PALETTE.stone500,
    axisLine: isDark ? PALETTE.stone600 : PALETTE.stone300,
    tooltipBorder: isDark ? PALETTE.stone600 : PALETTE.stone200,
    tooltipBg: isDark ? PALETTE.stone800 : PALETTE.white,
    tooltipColor: isDark ? PALETTE.stone50 : PALETTE.stone900,
    primary: PALETTE.sage500,
    primaryDark: PALETTE.sage600,
    dotOuter: PALETTE.stone50,
    dotInner: PALETTE.sage900,
  };
}

/** @returns {ReturnType<typeof getChartTheme>} */
export function useChartTheme() {
  const { resolvedTheme } = useTheme();
  return getChartTheme(resolvedTheme);
}

/**
 * Shared Recharts tooltip contentStyle object.
 * @param {'light'|'dark'} resolvedTheme
 */
export function chartTooltipStyle(resolvedTheme) {
  const t = getChartTheme(resolvedTheme);
  return {
    borderRadius: 8,
    border: `1px solid ${t.tooltipBorder}`,
    backgroundColor: t.tooltipBg,
    color: t.tooltipColor,
    fontSize: 13,
  };
}
